export default {
  name: 'Signalname',
  description: 'Beschreibung',
  color: 'Farbe',
  unit: 'Einheit',
  meaning: 'Bedeutung',
  meaningNumber: 'Instanz-Nr. der Bedeutung',
  numberOfSignificantDigits: 'Nachkommastellen',
  hidden: 'versteckt',
  visible: 'sichtbar',
  placeholder: {
    meaningId: 'Bedeutung auswählen',
    meaningInstanceNumber: 'Instanz-Nr.',
  },
};
